module.exports = __webpack_public_path__ + "static/img/btn_bg.8c5951c3.png";